import { useTranslation } from "react-i18next"
import { useEffect } from "react"
import CommonUtil from "../../../utils/CommonUtil"

const ConnectWifi = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('how_connect_wifi'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])
    return <div className="App">
        <div className="bind-device-faq">
            <span style={{ fontSize: 16, fontWeight: '500', color: '#000000', marginLeft: 25, marginTop: 15 }}>{t('connect_wifi_step1')}</span>
            {/* <span style={{ fontSize: 14, fontWeight: '500', color: '#333333', marginLeft: 25, marginTop: 10 }}>{t('connect_wifi_action1')}</span> */}
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 15, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('connect_wifi_action1_detail')}</span>
            </div>
            <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}bind_faq_step2.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div>
            {/* <span style={{ fontSize: 14, fontWeight: '500', color: '#333333', marginLeft: 25, marginTop: 10 }}>{t('connect_wifi_action2')}</span>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('connect_wifi_action2_detail')}</span>
            </div>
            <span style={{ fontSize: 16, fontWeight: '500', color: '#000000', marginLeft: 25, marginTop: 30 }}>{t('connect_wifi_step2')}</span>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('connect_wifi_step2_detail')}</span>
            </div> */}
            <div style={{ height: 40 }} />
        </div>
    </div>
}



export default ConnectWifi